import type { StaffUser } from '@/types/staff-user'
import { STAFF_PERMISSIONS } from '@/shared/permissions'
import { normalizeStaffPermissionList } from '@/shared/staff-permission-list'

const ADMIN_PANEL_PERMISSIONS = new Set<string>([
  STAFF_PERMISSIONS.staffUsersRead,
  STAFF_PERMISSIONS.staffUsersWrite,
  STAFF_PERMISSIONS.eventsRead,
  STAFF_PERMISSIONS.eventsWrite,
  STAFF_PERMISSIONS.catalogRead,
  STAFF_PERMISSIONS.catalogWrite,
  STAFF_PERMISSIONS.newsRead,
  STAFF_PERMISSIONS.newsWrite,
  STAFF_PERMISSIONS.mediaRead,
  STAFF_PERMISSIONS.mediaWrite,
  STAFF_PERMISSIONS.ordersRead,
  STAFF_PERMISSIONS.ordersWrite,
  STAFF_PERMISSIONS.paymentsRead,
  STAFF_PERMISSIONS.paymentsWrite,
  STAFF_PERMISSIONS.refundsWrite,
  STAFF_PERMISSIONS.reportsRead,
  STAFF_PERMISSIONS.financeRead,
  STAFF_PERMISSIONS.financeWrite,
  STAFF_PERMISSIONS.supportRead,
  STAFF_PERMISSIONS.supportWrite,
  STAFF_PERMISSIONS.auditRead,
  STAFF_PERMISSIONS.customersRead,
  STAFF_PERMISSIONS.customersWrite,
  STAFF_PERMISSIONS.settingsWrite,
  STAFF_PERMISSIONS.vendorsImpersonate,
  STAFF_PERMISSIONS.automationsManage,
  STAFF_PERMISSIONS.analyticsRead,
])

export function hasAdminPanelAccess(user: StaffUser | null | undefined): boolean {
  const permissions = normalizeStaffPermissionList(user?.role?.permissions)
  return permissions.includes('*') || permissions.some((permission) => ADMIN_PANEL_PERMISSIONS.has(permission))
}
